import type { LiveClient, LiveClientConfig, LiveProvider } from '@/transport/live/LiveClient';
import { SocketIoLiveClient } from '@/transport/live/socketio/SocketIoLiveClient';
import { WsLiveClient } from '@/transport/live/ws/WsLiveClient';

/**
 * Code-level provider swap point for the recorder. `ws` and `socket.io`
 * are implemented; `pusher` is reserved for later.
 */
export function createLiveClient(provider: LiveProvider, config: LiveClientConfig): LiveClient {
  switch (provider) {
    case 'ws':
      return new WsLiveClient(config);
    case 'socket.io':
      return new SocketIoLiveClient(config);
    case 'pusher':
      // In Pusher mode the recorder has no live connection — event batches are
      // ingested via REST and Pusher broadcasts to viewers server-side.
      // Recorder.ts skips createLiveClient entirely when the backend advertises
      // 'pusher', so this path is only reached if called directly (e.g. in tests).
      throw new Error(
        '[createLiveClient] Pusher provider does not use a recorder live client. ' +
          'The recorder always ingests via REST when the backend runs Pusher.'
      );
  }
}
